import { use, useSyncExternalStore } from "react";

export const DictionaryData = new Map();
const Subscribers = new Map();
export const EmmitChange = (key) => {
  if (Subscribers.has(key)) {
    for (const listener of Subscribers.get(key)) {
      listener();
    }
  }
};
export const useGenericStore = (key, defaultValue, postEvent = null) => {
  let defVal;
  if (typeof defaultValue?.then === "function") {
    defVal = use(defaultValue);
  } else {
    defVal = defaultValue;
  }
  return useSyncExternalStore(
    (callback) => {
      if (!Subscribers.has(key)) {
        Subscribers.set(key, new Set());
      }
      Subscribers.get(key).add(callback);
      return () => {
        if (Subscribers.has(key)) {
          Subscribers.get(key).delete(callback);
        }
      };
    },
    () => {
      if (DictionaryData.has(key)) {
        if (postEvent) {
          return postEvent(DictionaryData.get(key));
        }
        return DictionaryData.get(key);
      }
      return defVal;
    },
    () => {
      if (DictionaryData.has(key)) {
        if (postEvent) {
          return postEvent(DictionaryData.get(key));
        }
        return DictionaryData.get(key);
      }
      return defVal;
    },
  );
};
